import Rollbar from 'rollbar';
import {
  Injectable,
  Inject,
  InjectionToken,
  ErrorHandler,
} from '@angular/core';
import { environment } from '../environments/environment';
import { version } from '../environments/version';
import { User } from './models/user';

const rollbarConfig: Rollbar.Configuration = {
  accessToken: environment.rollbarAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: environment.env !== 'dev',
  environment: environment.env,
  exitOnUncaughtException: false,
  ignoredMessages: ['ResizeObserver is not supported in your browser'],
  ignoreDuplicateErrors: true,
  inspectAnonymousErrors: true,
  nodeSourceMaps: false,
  recorder: {
    enabled: true,
  },
  scrubRequestBody: true,
  stackTraceLimit: 20,
  wrapGlobalEventHandlers: false,
  // transform: function (payload: any) {
  //   const trace = payload.body.trace;
  //   if (trace && trace.frames) {
  //     for (const frame of trace.frames) {
  //       const filename = frame.filename;
  //       if (filename) {
  //         const matches = filename.match(
  //           /^(.*\/)((main|vendor)(-[a-z0-9]{16,})?\.js)$/i
  //         );
  //         if (matches && matches[2]) {
  //           frame.filename = `https://${matches[2]}`;
  //         }
  //       }
  //     }
  //   }
  // },
  payload: {
    environment: environment.env,
    client: {
      javascript: {
        source_map_enabled: true, //this is now true by default
        code_version: version.revision,
        // Optionally have Rollbar guess which frames the error was thrown from
        // when the browser does not provide line and column numbers.
        guess_uncaught_frames: true,
        autoInstrument: {
          networkRequestBody: true,
        },
      },
    },
  },
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable({
  providedIn: 'root',
})
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {}

  handleError(err): void {
    this.rollbar.error(err.originalError || err);
  }

  addRollbarPerson(user: User): void {
    if (user) {
      this.rollbar.configure({
        payload: {
          person: {
            id:
              user.id || user['https://agilitycoursemaster.com/userIdentifier'],
          },
        },
      });
    }
  }
}

export function rollbarFactory(): Rollbar {
  return new Rollbar(rollbarConfig);
}
